<script setup>

import { Field, FieldDescription, FieldLabel } from '../../../ui/field/index.js'
import { Input } from '../../../ui/input/index.js'
import { computed } from 'vue'

const modelValue = defineModel({ type: String, default: null })

import { formFieldProps, useFormField } from '@/composables/fields/useFormField.js'

// 1. Pass the imported object to defineProps
const props = defineProps(formFieldProps)

// 2. Pass the props to the composable to get your logic
const { inputId, isError, isSuccess } = useFormField(props)

</script>

<template>
  <Field>
    <FieldLabel v-if="props.label" :for="inputId">
      {{ props.label }}
    </FieldLabel>
    <Input :id="inputId" v-model:model-value="modelValue" :is-error="isError" :is-success="isSuccess" :placeholder="props.placeholder || ''" />
    <FieldDescription v-if="isError && props.errorMessage" class="text-destructive font-medium">
      {{ props.errorMessage }}
    </FieldDescription>
    <FieldDescription v-if="props.description">
      {{ props.description }}
    </FieldDescription>
  </Field>
</template>

<style scoped>

</style>
